<template>
  <b-slider
    v-model="sliderValue"
    class="is-primary"
    :min="0" :max="100"
  >
    <b-slider-tick title="Not applied" :value="0" :key="0">&#x25CE;</b-slider-tick>
    <b-slider-tick title="Exclude worse than benchmark" :value="50" :key="50">&#x25D0;</b-slider-tick>
    <b-slider-tick title="Exclude all" :value="100" :key="100">&#x25CF;</b-slider-tick>
  </b-slider>
</template>

<script>
  import Vue from 'vue';

  export default {
    data() {
      return {}
    },
    props: {
      screen: Object,
    },
    computed: {
      sliderValue: {
        get: function() {
          return this.screen.userPercentile;
        },
        set: function(value) {
          this.$emit('change', value);
        }
      }
    },
    methods: {
    },
    mounted: function() {
    },
    created: function() {
    }
  }
</script>

<style lang="scss">
</style>
